import { RegistrationDocuments } from 'components/RegistrationDocuments/RegistrationDocuments';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

export const RegistrationDocumentsPage = () => {
  return (
    <BaseLayout pageTitle="Registration documents | Introducer Portal">
      <RegistrationDocuments />
    </BaseLayout>
  );
};
